module.exports = __webpack_public_path__ + "static/media/bg1.3d3748b6.svg";